const cryptoDefault = [
  {
    id: 'bitcoin',
    symbol: 'btc',
    name: 'Bitcoin',
    image: 'https://assets.coingecko.com/coins/images/1/large/bitcoin.png?1547033579',
    current_price: 10899.96,
    market_cap: 201280725447,
    market_cap_rank: 1,
    fully_diluted_valuation: 228560510793,
    total_volume: 20706797630,
    high_24h: 11023.92,
    low_24h: 10834.55,
    price_change_24h: -40.21963416,
    price_change_percentage_24h: -0.36763,
    market_cap_change_24h: -1104702906.9398804,
    market_cap_change_percentage_24h: -0.54584,
    circulating_supply: 18493550,
    total_supply: 21000000,
    max_supply: 21000000,
    ath: 19665.39,
    ath_change_percentage: -44.63285,
    ath_date: '2017-12-16T00:00:00.000Z',
    atl: 67.81,
    atl_change_percentage: 15957.11557,
    atl_date: '2013-07-06T00:00:00.000Z',
    roi: null,
    last_updated: '2020-09-18T21:37:35.164Z',
  },
  {
    id: 'ethereum',
    symbol: 'eth',
    name: 'Ethereum',
    image: 'https://assets.coingecko.com/coins/images/279/large/ethereum.png?1595348880',
    current_price: 380.58,
    market_cap: 42829378776,
    market_cap_rank: 2,
    fully_diluted_valuation: null,
    total_volume: 13099080510,
    high_24h: 393.8,
    low_24h: 377,
    price_change_24h: -12.83107588,
    price_change_percentage_24h: -3.2615,
    market_cap_change_24h: -1447405348.3560715,
    market_cap_change_percentage_24h: -3.26899,
    circulating_supply: 112657721.8115,
    total_supply: null,
    max_supply: null,
    ath: 1448.18,
    ath_change_percentage: -73.71391,
    ath_date: '2018-01-13T00:00:00.000Z',
    atl: 0.432979,
    atl_change_percentage: 87818.87148,
    atl_date: '2015-10-20T00:00:00.000Z',
    roi: {
      times: 45.70964780562845,
      currency: 'btc',
      percentage: 4570.964780562845,
    },
    last_updated: '2020-09-18T21:35:18.871Z',
  },
  {
    id: 'tether',
    symbol: 'usdt',
    name: 'Tether',
    image: 'https://assets.coingecko.com/coins/images/325/large/Tether-logo.png?1598003707',
    current_price: 1,
    market_cap: 15140513200,
    market_cap_rank: 3,
    fully_diluted_valuation: null,
    total_volume: 39127673452,
    high_24h: 1,
    low_24h: 0.998819,
    price_change_24h: -0.00008748,
    price_change_percentage_24h: -0.00873,
    market_cap_change_24h: 64642163,
    market_cap_change_percentage_24h: 0.42878,
    circulating_supply: 15116799952.6802,
    total_supply: 10166574840,
    max_supply: null,
    ath: 1.32,
    ath_change_percentage: -24.30109,
    ath_date: '2018-07-24T00:00:00.000Z',
    atl: 0.572521,
    atl_change_percentage: 74.94008,
    atl_date: '2015-03-02T00:00:00.000Z',
    roi: null,
    last_updated: '2020-09-18T21:07:24.447Z',
  },
];

export default cryptoDefault;
